import Model from '../BaseModel'
import i18n from '@/plugins/i18n'

export default class Mail extends Model {
    resourceName() {
        return 'mail-settings'
    }

    fields() {
        return ['subject', 'recipients', 'bcc', 'variables', 'content']
    }

    computed() {
        return {
            recipientsAsString(mail) {
                return mail.recipients.join(', ')
            },

            bccAsString(mail) {
                return mail.bcc.join(', ')
            },

            parsedVariables(mail) {
                let variables = []

                mail.variables.forEach(variable => {
                    if (typeof variable === 'string') {
                        variables.push({ name: variable })
                        return
                    }

                    variables.push(variable)
                })

                return variables
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.mail.attributes.subject'),
                value: 'subject',
                sortable: true,
            },
            {
                text: i18n.t('resources.mail.attributes.recipients'),
                value: 'recipientsAsString',
                sortable: false,
            },
            {
                text: i18n.t('resources.mail.attributes.bcc'),
                value: 'bccAsString',
                sortable: false,
            },
            {
                text: i18n.t('resources.default.actions'),
                value: 'action',
                sortable: false,
            },
        ]
    }
}
